'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('landusemap', {
      url: '/landusemap',
      template: '<landusemap></landusemap>'
    });
}



// WEBPACK FOOTER //
// ./client/app/landusemap/landusemap.routes.js